<template>
  <div class="offer-form-section">
    <div v-if="offerType === 'bonus-points' || offerType === 'coupon'">
      <label :class="['data-description', 'coupon-label', { ['error-label']: errors.name }]">offer for customer</label>
      <input
        type="text"
        :name="[referredMessaged ? 'referral_item_name' : 'item_name']"
        class="item-name-input"
        v-model="couponName"
        @blur="checkUserInteraction('name')"
        @input="setDelayedUpdate('name', { item_name: couponName })" />
      <span class="error-label error-message" v-if="errors.name">{{errors.name}}</span>
    </div>

    <div v-if="offerType === 'bonus-points'">
      <label :class="['data-description', 'bonus-type-label', { ['error-label']: errors.bonusType }]">bonus type</label>
      <div class="bonus-type">
        <label class="bonus-type-container" :for="'type-add-'+ offerId">
          <input
            v-model="bonusTypeSelection"
            class="bonus-type-radio"
            type="radio"
            value="add"
            :name="'bonus_type'+ offerId"
            :id="'type-add-'+ offerId"
            :checked="bonusTypeSelection === 'add'"
            @click="updateBonusType">
          <span class="radio add text-center">
            <span>+</span>
            <small>add</small>
          </span>
        </label>
        <label class="bonus-type-container" :for="'type-multiply-'+ offerId">
          <input
            v-model="bonusTypeSelection"
            class="bonus-type-radio"
            type="radio"
            value="multiply"
            :name="'bonus_type'+ offerId"
            :id="'type-multiply-'+ offerId"
            :checked="bonusTypeSelection === 'multiply'"
            @click="updateBonusType">
          <span class="radio multiply text-center">
            <span>x</span>
            <small>multiply</small>
          </span>
        </label>
      </div>
    </div>
    <div v-if="offerType === 'bonus-points' || offerType === 'instant-points'">
      <label v-if="offerType === 'bonus-points'" :class="['data-description', 'bonus-value-label', { ['error-label']: errors.bonusValue }]">bonus value</label>
      <label v-else :class="['data-description', 'bonus-value-label', { ['error-label']: errors.bonusValue }]">points to be issued instantly</label>
      <input
        v-model="bonusValueInput"
        value="0"
        class="bonus-value"
        type="number"
        name="bonus_value"
        min="0"
        step="1"
        @blur="checkUserInteraction('bonusValue')"
        @input="setDelayedUpdate('bonusValue', { bonus_value: bonusValueInput })" />
      <span class="error-label error-message" v-if="errors.bonusValue">{{errors.bonusValue}}</span>
    </div>
    <div v-if="offerType === 'bonus-points' || offerType === 'coupon'">
      <label class="data-description max-redemptions-label">offers per customer</label>
      <select
        v-model="maxUses"
        @change="updateMaxRedemptions"
        :name="[referredMessaged ? 'referral_max_redemptions' : 'max_redemptions']"
        class="max-redemptions">
        <option value="-1">unlimited</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="10">10</option>
      </select>
      <div v-if="isCampaign" class="expiration-wrapper">
        <label :class="['data-description', 'expiration-label', { ['error-label']: errors.expiry }]">expiration date</label>
        <span class="expiration-details">expires at 11:59 PM</span>
        <flat-pickr v-model="expiration"
                    :config="config"
                    class="control-expiration"
                    name="expiration"
                    @blur="checkUserInteraction('expiry')"
                    @on-close="delayUpdateExpiry">
        </flat-pickr>
        <span class="error-label error-message" v-if="errors.expiry">{{errors.expiry}}</span>
      </div>
      <div v-else-if="rewardOwner.type === 'AutoCampaignMessage'" class="expiry-days-wrapper" >
        <label :class="['data-description', { ['error-label']: errors.expiry }]">offer expires after</label>
        <input
          v-model="expiry"
          class="expiry-days"
          type="number"
          :name="[referredMessaged ? 'referral_expiry_days' : 'expiry_days']"
          min="0"
          step="1"
          @blur="checkUserInteraction('expiry')"
          @input="setDelayedUpdate('expiry', { expiry_date_in_days: expiry })">
        <span>days</span>
        <span class="error-label error-message" v-if="errors.expiry">{{errors.expiry}}</span>
      </div>
    </div>


    <div v-if="offerType === 'bonus-points'">
      <label class="data-description min-purchase-label">min purchase amount</label>
      <input
        v-model="minPurchase"
        value="0"
        class="min-purchase"
        type="number"
        name="min_purchase"
        placeholder="$0.00"
        min="0"
        step="0.1"
        @input="setDelayedUpdate('minPurchase', { min_purchase_amount: minPurchase })" />
    </div>

    <reward-attachments :rewardId="offerId"
                        :rewardOwnerId="rewardOwner.id"
                        :rewardOwnerType="rewardOwner.type"
                        :rewardAttachmentUploads="rewardAttachmentUploads"></reward-attachments>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment-timezone'
  import RewardAttachments from '../Rewards/RewardAttachments'

  export default {
    props: {
      bonusType: String,
      bonusValue: [Number, String],
      campaignSendTime: String,
      expirationDate: String,
      expiryDays: Number,
      itemName: String,
      maxRedemptions: Number,
      minPurchaseAmount: Number,
      offerType: String,
      offerId: Number,
      referredMessaged: Boolean,
      rewardAttachmentUploads: Array,
      rewardOwner: Object,
    },

    components: {
      flatPickr,
      RewardAttachments,
    },

    data() {
      return {
        bonusTypeSelection: null,
        bonusValueInput: null,
        config: {
          altFormat: "D, M j",
          altInput: true,
          altInputClass: 'flatpickr-input',
          dateFormat: 'Y-m-d',
          minDate: new Date()
        },
        couponName: '',
        delayedUpdate: {
          field: null,
          timeout: null,
        },
        errors: {
          bonusType: null,
          bonusValue: null,
          expiry: null,
          name: null,
        },
        expiration: null,
        expiry: null,
        maxUses: null,
        minPurchase: 0,
        noInteraction: {
          expiry: true,
          name: true,
        },
        validOfferForm: false,
      }
    },

    methods: {
      checkErrorsAndUpdate(errorKey, fieldToUpdate) {
        this.validateItem(errorKey)
        if (!this.errors[errorKey]) { this.$emit('updateOffer', fieldToUpdate) }
      },

      checkUserInteraction(offerKey) {
        if (this.noInteraction[offerKey]) {
          this.$set(this.noInteraction, offerKey, false)
          this.validateItem(offerKey)
          this.$emit('updateUserInteractions', Object.values(this.noInteraction).includes(true))
        }
      },

      clearDelayedUpdate(item) {
        const field = this.delayedUpdate.field
        if (field && field === item) { clearTimeout(this.delayedUpdate.timeout) }
      },

      delayUpdateExpiry(selectedDates, dateStr) {
        this.expiration = dateStr
        this.$set(this.noInteraction, 'expiry', false)
        this.$emit('updateUserInteractions', Object.values(this.noInteraction).includes(true))
        this.setDelayedUpdate('expiry', { expiration_date_local: this.expiration})
      },

      setBonus(removeBonus) {
        if (removeBonus) {
          this.$delete(this.noInteraction, 'bonusType')
          this.$delete(this.noInteraction, 'bonusValue')
        } else {
          this.$set(this.noInteraction, 'bonusType', !this.bonusType)
          this.$set(this.noInteraction, 'bonusValue', !this.bonusValue)
        }
        this.$emit('updateUserInteractions', Object.values(this.noInteraction).includes(true))
      },

      setInstantPoints(removeInstantPoints) {
        if (removeInstantPoints) {
          const emptyExpiry = this.isCampaign ? !this.expiration : !this.expiry
          this.$delete(this.noInteraction, 'bonusValue')
          this.$set(this.noInteraction, 'expiry', emptyExpiry)
          this.$set(this.noInteraction, 'name', !this.couponName)
        } else {
          this.$set(this.noInteraction, 'bonusValue', !this.bonusValue)
          this.$delete(this.noInteraction, 'expiry')
          this.$delete(this.noInteraction, 'name')
        }
        this.$emit('updateUserInteractions', Object.values(this.noInteraction).includes(true))
      },

      setDelayedUpdate(item, fieldToUpdate) {
        this.clearDelayedUpdate(item)
        this.delayedUpdate.field = item
        this.delayedUpdate.timeout = setTimeout(() => this.checkErrorsAndUpdate(item, fieldToUpdate), 500)
      },

      setValues() {
        this.couponName = this.itemName
        this.maxUses = this.maxRedemptions
        this.expiration = this.expirationDate
        this.expiry = this.expiryDays ? -1*(this.expiryDays / 86400) : ''
        this.bonusTypeSelection = this.bonusType
        this.bonusValueInput = this.bonusValue
        this.minPurchase = this.minPurchaseAmount

        if (this.expirationDate && this.isCampaign) { this.checkUserInteraction('expiry') }
        if (this.expiry && !this.isCampaign) { this.checkUserInteraction('expiry') }
        if (this.itemName) { this.checkUserInteraction('name') }
        if (this.offerType === 'bonus-points') {
          this.setBonus()
        } else if (this.offerType === 'instant-points') {
          this.setInstantPoints()
        }
      },

      updateBonusType(event) {
        this.checkUserInteraction('bonusType')
        const clickedType = event.target.value,
          isValid = (clickedType === 'multiply' ||  clickedType === 'add'),
          shouldUpdate = clickedType !== this.bonusType
        this.$set(this.errors, 'bonusType', !isValid)
        this.validateOfferForm()
        if (!this.errors.bonusType && shouldUpdate) {
          this.bonusTypeSelection = clickedType
          this.$emit('updateOffer', { bonus_type: clickedType })
        }
      },

      updateMaxRedemptions(event) {
        this.$emit('updateOffer', { max_redemptions: event.target.value })
      },

      validateBonusValue() {
        const isInvalid = this.bonusValueInput < 1 || !this.bonusValueInput.length,
          error = isInvalid ? 'bonus value must be entered' : null
        this.$set(this.errors, 'bonusValue', error)
        this.validateOfferForm()
      },

      validateExpiration() {
        const expirationEndOfDay = moment(this.expiration).format("YYYY-MM-DD 23:59")
        if (!this.expiration || !this.expiration.length) {
          this.$set(this.errors, 'expiry', 'must select expiration date')
        } else if (expirationEndOfDay < this.campaignSendTime) {
          this.$set(this.errors, 'expiry', "can't expire before campaign send time")
        } else {
          this.$set(this.errors, 'expiry', null)
        }
        this.validateOfferForm()
      },

      validateExpiry() {
        if (!this.expiry) {
          this.$set(this.errors, 'expiry', 'must select expiration date')
        } else {
          this.$set(this.errors, 'expiry', null)
        }
        this.validateOfferForm()
      },

      validateItem(item) {
        switch (item) {
          case 'bonusValue':
            this.validateBonusValue()
            break
          case 'expiry':
            this.isCampaign ? this.validateExpiration() : this.validateExpiry()
            break
          case 'name':
            this.validateName()
            break
        }
      },

      validateName() {
        if (!this.couponName) {
          this.$set(this.errors, 'name', "offer name can't be blank")
        } else {
          this.$set(this.errors, 'name', null)
        }
        this.validateOfferForm()
      },

      validateOfferForm() {
        const validName = (!this.errors.name || this.noInteraction.name),
          validExpiry = (!this.errors.expiry || this.noInteraction.expiry),
          validCoupon = validName && validExpiry

        if (this.offerType === 'coupon') {
          this.validOfferForm = validCoupon
        } else if (this.offerType === 'bonus-points') {
          const validBonusType = (!this.errors.bonusType || this.noInteraction.bonusType),
            validBonusValue = (!this.errors.bonusValue || this.noInteraction.bonusValue)
          this.validOfferForm = validCoupon && validBonusType && validBonusValue
        } else if (this.offerType === 'instant-points') {
          this.validOfferForm = !this.errors.bonusValue || this.noInteraction.bonusValue
        }
        this.$emit('validOffer', this.validOfferForm)
      },
    },

    mounted() {
      this.setValues()
      this.$emit('updateUserInteractions', Object.values(this.noInteraction).includes(true))
    },

    computed: {
      isCampaign: function () {
        return this.rewardOwner?.type === 'Campaign'
      }
    },

    watch: {
      campaignSendTime: function() {
        this.validateOfferForm()
      },

      offerType: function() {
        this.bonusTypeSelection = this.bonusType
        this.maxUses = this.maxRedemptions
        this.setBonus(this.offerType !== 'bonus-points')
        this.setInstantPoints(this.offerType !== 'instant-points')
        this.validateOfferForm()
      },
    }
  }
</script>